export enum JSAPISupportedMethod {
    PaymentDialog = 'showPaymentDialog',
    JSAPIDialog = 'showJSAPIDialog',
    ReadHash = 'readHash',
    WriteHash = 'writeHash',
}

export enum JSAPIDialogTemplate {
    FriendsInvitation = 'friends.invite',
    StreamPublish = 'stream.post',
}

export enum AppEventName {
    MailruAppEventsFriendsInvitation = 'mailru.app.events.friendsInvitation',
    AppFriendsInvitation = 'app.friendsInvitation',
    CommonStreamPublish = 'common.streamPublish',
    ReadHash = 'app.appReadHash'
}
